import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";
import { Badge } from "../../base/badge/badge";
/** Tag per level — a lookup rather than a template literal, so the type stays exact. */ const HEADING_TAGS = {
    1: "h1",
    2: "h2",
    3: "h3"
};
/**
 * Detail-page heading with the red "Deleted" badge for soft-deleted entities.
 * Shared by the entity detail pages (artifact, org member, team, system,
 * external contact) so the tombstone presentation stays uniform, and by the
 * chat's embedded entity views.
 */ export function EntityDetailTitle({ name, deletedAt, headingLevel = 1 }) {
    const { t } = useTranslation();
    const Heading = HEADING_TAGS[headingLevel];
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex items-center gap-2",
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: "text-xl font-semibold leading-7",
                children: name
            }),
            deletedAt ? /*#__PURE__*/ _jsx(Badge, {
                variant: "destructive",
                children: t("common.deleted")
            }) : null
        ]
    });
}

//# sourceMappingURL=entity-detail-title.js.map